// client/src/hooks/useContactInfo.js
import { useState, useCallback, useEffect } from 'react';
import api from '../services/api';
import useAlert from './useAlert'; 

export const useContactInfo = () => {
    const [contactInfo, setContactInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { setAlert } = useAlert(); 

    const fetchContactInfo = useCallback(async () => {
        try {
            setLoading(true);
            // ✅ Rota ADMIN — a rota pública sempre retorna o dado da Matriz;
            // dentro do painel, leitura e escrita precisam apontar pro mesmo
            // lugar (a rota admin, que exige matriz por enquanto — ver
            // institucionalRoutes.js).
            const response = await api.get('/admin/institucional/contact-info');
            setContactInfo(response.data.data);
            setError(null); 
        } catch (err) {
            const errorMessage = err.response?.data?.error || err.response?.data?.message || 'Erro ao buscar informações de contato';
            setError(errorMessage);
            // setAlert(errorMessage, 'error'); // Opcional: só se quiser alertar sobre o GET falho
        } finally {
            setLoading(false);
        }
    }, []);

    const updateContactInfo = useCallback(async (data) => {
        try {
            setLoading(true);
            // ✅ Rota PROTEGIDA (admin) para atualizar as informações de contato
            const response = await api.put('/admin/institucional/contact-info', data); 
            setContactInfo(response.data.data);
            setAlert('Informações de contato atualizadas com sucesso!', 'success'); 
            return response.data;
        } catch (err) {
            const errorMessage = err.response?.data?.error || err.response?.data?.message || 'Erro ao atualizar as informações de contato';
            setAlert(errorMessage, 'error'); 
            throw new Error(errorMessage);
        } finally {
            setLoading(false);
        }
    }, [setAlert]); 

    useEffect(() => {
        fetchContactInfo();
    }, [fetchContactInfo]);

    return {
        contactInfo,
        loading,
        error,
        updateContactInfo,
        refetch: fetchContactInfo
    };
};